import { useEffect, useRef, useState } from 'react'

import { animationOpacityIn } from 'style'
import { create } from 'zustand'

type Animation = string

interface AnimationsState {
  items: Animation[]
}

const initialState: AnimationsState = {
  items: [],
}

const useAnimationsStore = create<AnimationsState>(() => initialState)

type UseAnimationProps = {
  key: string
  animation?: string
}

export const useAnimation = (props: UseAnimationProps) => {
  const { key, animation = animationOpacityIn } = props
  const animations = useAnimationsStore(s => s.items)
  const [internalAnimation, setInternalAnimation] = useState<string>()

  const animationKey = useRef(key)

  useEffect(() => {
    const exists = animations.some(k => k === animationKey.current)

    if (!exists) {
      useAnimationsStore.setState(s => ({
        items: [...s.items, animationKey.current],
      }))
      setInternalAnimation(animation)
    }
  }, [animation, animations])

  return {
    animation: internalAnimation,
  }
}
